import * as React from 'react';
import MainRouter from 'scenes/MainRouter';
import { AppProps, mapDispatchToProps, mapStateToProps, RefContext } from 'App/app.scheme';
import useStyles from './app.styles';
import SideMenu from 'components/SideMenu';
import { CssBaseline, Hidden, ThemeProvider } from '@material-ui/core';
import createMuiTheme from 'muiTheme/theme/createMuiTheme';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import MomentUtils from '@date-io/moment';
import { useTranslation } from 'react-i18next';
import { onChangeLng } from 'i18n';
import { getLanguageDirection, localesCodeMap } from 'config/i18n';
import { connect } from 'react-redux';
import config from 'config/common';
import SnackbarWrapper from './components/SnackbarWrapper';
import { matchPath, useHistory, useLocation } from 'react-router-dom';
import { mixPanelEventsTypes } from 'helpers/analyticsManager';
import Header from 'components/Header';
import moment from 'moment';
import MsgPopup from 'components/MsgPopup';
import WhatsAppButton from 'components/WhatsAppButton/whatsAppButton.render';
import { getAllSearchParamsAsObject, getSearchParamFromUrl } from 'helpers/urlParamaters';
import i18n from 'i18next';
import site24x7 from 'services/site24x7';
import MobileBottomNavigation from '../components/BottomNavigation';
import { Pages } from 'interfaces/main';
import { isMobile, isTablet } from 'helpers/device_helper';
import Disclaimer from './components/Disclaimer';
import DisclaimerEu from './components/Disclaimer-eu';
import LogRocket from 'logrocket';
import useDeviceType from 'hooks/useDeviceType';
import VersionPopup from './components/VersionPopup/version-popup.render';
import ChatDrawer from 'components/ChatDrawer/chat-drawer.render';
import useDisableBottomNavOnNewChallenge from 'components/BottomNavigation/useDisableBottomNavOnNewChallenge';
import useDisableMainBottomMargin from 'hooks/useDisableMainBottomMargin';
import { useSetDepositResults } from 'features/prop/hooks/useSetDepositResults';
import TradersEducationDialog from 'features/prop/scenes/Checkout/components/TradersEducationDialog/tradersEducationDialog.render';
import FundedInvestingManualKycDialogWithStoreConnection from 'features/prop/scenes/MyChallenges/components/FundedInvestingManualKycDialog/fundedInvestingManualKycDialogWithStoreConnection';
import ChallengeRetryDialog from 'features/prop/scenes/MyChallenges/components/ChallengeRetryDialog/challengeRetryDialog.render';
import ChallengeRetryDisabledDialog from 'features/prop/scenes/MyChallenges/components/ChallengeRetryDisabledDialog/challengeRetryDisabledDialog.render';
import SplashLoaderFullScreen from 'components/SpalshLoaderFullScreen';
import IntercomChat from 'components/IntercomChat/IntercomChat.render';
import LoaderFullScreen from 'components/LoaderFullScreen';
import analyticsManager from 'helpers/analyticsManager';
import { useCurrentUrl } from 'hooks/useCurrentUrl';
import usePreviousPathname from 'hooks/usePreviousPathname';
import { challengeKeeperKey } from 'utils/keeper.utils';
import { useHideLayout } from 'features/prop/hooks/useDisplayLayout';
import { useIsPspIframeOpen } from 'features/prop/hooks/useIsPspIframeOpen';
import { initProductFruits } from 'helpers/productfruits';
import { useEnableKeeperButton } from 'features/prop/hooks/useEnableKeeperButton';
import { solitics } from 'helpers/solitics';
import { useDisableKeeperAlert } from 'features/prop/hooks/useDisableKeeperAlert';
import { useKeeperBanner } from 'hooks/useKeeperBanner';
import { ReviewedMixpanelEvents } from 'helpers/mixpanelReviewedEvents';

import KeeperAlertModal, {
    KeeperAlertContent,
    StyleOption,
} from 'features/prop/scenes/MyChallenges/components/KeeperAlertModal/KeeperAlertModal';
import DynamicScripts from 'components/DynamicScripts/DynamicScripts';
import { useFeatureScripts } from './useFeatureScripts';
import ReferAndEarnPopup from 'components/ReferAndEarnPopup/referAndEarnPopup.render';
import { useReferAndEarnPopup, ReferAndEarnSource } from 'hooks/useReferAndEarnPopup';
import { useReferAndEarnQueryParam } from 'features/prop/hooks/useReferAndEarnQueryParam';

const App: React.FunctionComponent<AppProps> = (props) => {
    const {
        selectedChallenge,
        hasJwtToken,
        loggedIn,
        systemLoader,
        systemTheme,
        user_getUserData,
        userVerified,
        ipData,
        auth_getIpData,
        countryLanguages,
        system_side_menu_state,
        system_deviceTypeSize,
        prop__myPlans_getPlans,
        getNewGoal,
        mainTpAccount,
        getPaymentTypes,
        getPromoDiscountCodes,
        payment_resetState,
        payment_setDepositType,
        payment_setDepositResult,
        depositType,
        system_getCountries,
        system_toggleEducationModal,
        prop_getAdditionalInfoFromMonetaryTransactions,
        educationModalState,
        platform_getMteIframeUrl,
        userInfo,
        config_loader,
    } = props;
    const history = useHistory();
    const { listen } = history;
    const location = useLocation();
    const currentUrl = useCurrentUrl();
    const previousPathname = usePreviousPathname();
    const hideLayoutLayout = useHideLayout();
    const disableKeeperAlert = useDisableKeeperAlert();
    const isPspIframeOpen = useIsPspIframeOpen();
    const features = useFeatureScripts();
    const [currentModalIndex, setCurrentModalIndex] = React.useState(0);
    const useDisableBottomNav = useDisableBottomNavOnNewChallenge();
    const disableMainBottomMargin = useDisableMainBottomMargin();
    const scrollToTopElement = React.useRef<any>(null);
    const deviceType = useDeviceType();
    const {
        isOpen: referAndEarnPopupOpen,
        openPopup: openReferAndEarnPopup,
        closePopup: closeReferAndEarnPopup,
    } = useReferAndEarnPopup();

    // Wrapper to track source as Navigation Bar
    const handleReferAndEarnClick = React.useCallback(() => {
        openReferAndEarnPopup(ReferAndEarnSource.NAVIGATION_BAR);
    }, [openReferAndEarnPopup]);
    const myRef = React.useRef<HTMLElement>(null);

    // Handle referAndEarn query param: show popup when script is ready
    useReferAndEarnQueryParam();

    const { isKeeperActive: enableKeeperButton, keeperActiveTypes } = useEnableKeeperButton({
        challengeId: selectedChallenge?.id ?? '',
        planId: selectedChallenge?.plan ?? '',
    });

    const {
        i18n: { language },
    } = useTranslation();

    const [appLanguage, setAppLanguage] = React.useState<string>(language);
    const [splashScreenOn, setSplashScreenOn] = React.useState(true);
    const isPlatformPage = location.pathname.includes(`/${Pages.PLATFORMS}/home`);

    const { filteredKeeperActiveTypesForBanner, isOpenKeeperBanner, handleCloseKeeperBannerAction } = useKeeperBanner(
        keeperActiveTypes,
        selectedChallenge?.id,
        challengeKeeperKey
    );

    const currentBannerType = React.useMemo(() => {
        if (currentModalIndex < filteredKeeperActiveTypesForBanner.length) {
            return filteredKeeperActiveTypesForBanner[currentModalIndex];
        }
        return filteredKeeperActiveTypesForBanner[0];
    }, [currentModalIndex, filteredKeeperActiveTypesForBanner]);

    const showNextModal = React.useCallback(() => {
        setCurrentModalIndex((prevIndex) => {
            const nextIndex = prevIndex + 1;
            return nextIndex;
        });
    }, [keeperActiveTypes.length]);

    const filteredKeeperActiveTypes = React.useMemo(() => {
        return keeperActiveTypes.filter((type) => localStorage.getItem(`${challengeKeeperKey}-${type}`) !== 'closed');
    }, [keeperActiveTypes]);

    const currentType = React.useMemo(() => {
        if (currentModalIndex < filteredKeeperActiveTypes.length) {
            return filteredKeeperActiveTypes[currentModalIndex];
        }
        return filteredKeeperActiveTypes[0];
    }, [currentModalIndex, filteredKeeperActiveTypes]);

    React.useEffect(() => {
        if (!systemLoader) {
            setSplashScreenOn(false);
        }
    }, [systemLoader]);

    const isEconomicCalendarPage = matchPath(location.pathname, {
        path: `/${Pages.ECONOMIC_CALENDAR}`,
        exact: true,
        strict: false,
    });

    const classes = useStyles({
        theme: systemTheme,
        loggedIn,
        fixedDisclaimerRow: config.theme.fixedDisclaimerRow,
        system_side_menu_state,
        disableMainBottomMargin,
        isEconomicCalendarPage: !!isEconomicCalendarPage,
    });

    React.useEffect(() => {
        auth_getIpData();
        system_getCountries();
    }, [system_getCountries, auth_getIpData]);

    useSetDepositResults({
        depositType,
        payment_resetState,
        payment_setDepositType,
        payment_setDepositResult,
    });

    React.useEffect(() => {
        user_getUserData();
    }, [user_getUserData, hasJwtToken]);

    React.useEffect(() => {
        site24x7.init();
    }, []);

    React.useEffect(() => {
        if (config.featuresFlags['mte'] && mainTpAccount?.id) platform_getMteIframeUrl(mainTpAccount.id);
    }, [mainTpAccount?.id]);

    React.useEffect(() => {
        if (loggedIn) {
            getNewGoal();
            prop__myPlans_getPlans();
            getPromoDiscountCodes(true);
        }
    }, [getNewGoal, getPromoDiscountCodes, loggedIn, prop__myPlans_getPlans]);

    React.useEffect(() => {
        if (loggedIn && mainTpAccount?.id) {
            getPaymentTypes(mainTpAccount?.id || '');
            prop_getAdditionalInfoFromMonetaryTransactions(mainTpAccount?.id || '');
        }
    }, [getPaymentTypes, loggedIn, mainTpAccount?.id]);

    React.useEffect(() => {
        if (config?.logRocketId) {
            LogRocket.init(config.logRocketId);
        }
    }, []);

    React.useEffect(() => {
        const appVisibilityChange = () => {
            const lastVisible = localStorage.getItem('lastVisibleTime');
            if (document.visibilityState === 'visible' && Number(lastVisible) + 30000 < Date.now()) {
                window.parent.location.reload();
            } else {
                localStorage.setItem('lastVisibleTime', Date.now().toString());
            }
        };

        const isWrapperApp: string | undefined | null = getSearchParamFromUrl('app') || localStorage.getItem('app');
        if (isWrapperApp === 'ios' || isWrapperApp === 'android') {
            localStorage.setItem('app', isWrapperApp);
            document.addEventListener('visibilitychange', appVisibilityChange);
        }
        return () => {
            document.removeEventListener('visibilitychange', appVisibilityChange);
        };
    }, []);

    React.useEffect(() => {
        const searchParams = getAllSearchParamsAsObject();
        const filteredParams = {};

        Object.keys(searchParams).forEach((key) => {
            if (key.startsWith('mi_')) {
                const filteredKey = key.substring(3);
                filteredParams[filteredKey] = searchParams[key];
            }
        });

        if (Object.keys(filteredParams).length > 0) {
            const miParams = localStorage.getItem('appMiParams');
            const storedParams = miParams ? JSON.parse(miParams) : {};
            const mergedParams = { ...storedParams, ...filteredParams };
            localStorage.setItem('appMiParams', JSON.stringify(mergedParams));
        }
    }, []);

    React.useEffect(() => {
        onLanguageChange(language);
    }, [language]);

    React.useEffect(() => {
        system_deviceTypeSize(deviceType);
    }, [deviceType, system_deviceTypeSize]);

    // set language based on country ip
    React.useEffect(() => {
        if (!localStorage.getItem('countryLangRedirected') && !getSearchParamFromUrl('lang') && !loggedIn) {
            let countryLangs = countryLanguages || [];
            // let existsLang = countryLangs.find((lng)=> localesCodeMap.includes(lng)) || null;
            let existsLang = localesCodeMap.find((lng) => lng === countryLangs[0]);
            if (existsLang) {
                i18n.changeLanguage(existsLang);
                localStorage.setItem('countryLangRedirected', '1');
            }
        }
    }, [loggedIn, ipData, countryLanguages]);

    React.useEffect(() => {
        const iframePlaceholder = document.getElementById('platformIframePlaceholder');
        const iframe = document.getElementById('platformIframe');

        if (!loggedIn && iframe && iframePlaceholder) {
            iframePlaceholder['accountName'] = undefined;
            iframe.remove();
        }
    }, [loggedIn]);

    //TODO: Check ProductFruits
    React.useEffect(() => {
        if (loggedIn && userInfo.id && ipData?.country && language) {
            initProductFruits({
                siteId: config.productFruitsId,
                username: userInfo.id,
                firstName: userInfo.firstName ?? '',
                lastName: userInfo.lastName ?? '',
                Account_GUID: userInfo?.id,
                country: ipData?.country,
                language: language,
                Affiliate: userInfo?.marketingInfo?.affiliate ?? '',
                UTM_Campaign: userInfo?.marketingInfo?.utmCampaign ?? '',
                props: {
                    accountGuid: userInfo?.id,
                    country: ipData?.country,
                    affiliate: userInfo?.marketingInfo?.affiliate ?? '',
                    utmCampaign: userInfo?.marketingInfo?.utmCampaign ?? '',
                },
            });
        }
    }, [loggedIn, userInfo.id, ipData?.country, language]);

    React.useEffect(() => {
        const historyListen = listen(({ pathname: pathname }) => {
            if (previousPathname && previousPathname !== pathname) {
                solitics.leavePage(previousPathname, {
                    nextPage: pathname,
                    url: currentUrl,
                    platform: window.location.hostname,
                });
            }

            analyticsManager.trackEvent(ReviewedMixpanelEvents.PAGE_VIEWED, {
                language,
                theme: systemTheme,
                pageName: pathname,
                previousPage: previousPathname,
                url: currentUrl,
                platform: window.location.hostname,
            });
            solitics.enterPage(pathname, {
                previousPage: previousPathname,
                url: currentUrl,
                platform: window.location.hostname,
            });

            setTimeout(() => {
                if (scrollToTopElement && scrollToTopElement.current) {
                    scrollToTopElement.current.scroll({ top: 0, left: 0, behavior: 'smooth' });
                }
            }, 100);
        });
        return () => {
            historyListen();
        };
    }, [listen, language, systemTheme, previousPathname]);

    React.useEffect(() => {
        analyticsManager.trackEvent(ReviewedMixpanelEvents.PAGE_VIEWED, {
            language,
            theme: systemTheme,
            pathname: location.pathname,
            url: currentUrl,
            platform: window.location.hostname,
        });
    }, []);
    const isKeeperBannerShouldOpen = enableKeeperButton && isPlatformPage && loggedIn && isMobile();

    //~~~React Effect Functions
    const onLanguageChange = (newLanguage: string) => {
        try {
            switch (newLanguage) {
                case 'en':
                    break;
                case 'cn':
                    require(`moment/locale/zh-cn`);
                    break;
                default:
                    require(`moment/locale/${newLanguage}`);
                    break;
            }
            moment.locale(newLanguage);
        } catch (error) {
            moment.locale('en');
        }
        onChangeLng(newLanguage);
        setAppLanguage(newLanguage); // force app to rebuild on language change
    };

    React.useEffect(() => {
        if (!systemLoader) {
            const windowAny = window as any;
            // IOS wrapper ready
            if (windowAny?.webkit?.messageHandlers?.callbackHandler?.postMessage) {
                windowAny.webkit.messageHandlers.callbackHandler.postMessage(
                    JSON.stringify({
                        action: 'showapp',
                    })
                );
            }

            // Android wrapper ready
            if (windowAny?.nativeWrapper?.showApp) {
                windowAny.nativeWrapper.showApp();
            }

            window.removeEventListener('online', windowAny.mainIndexOnline);
            window.removeEventListener('offline', windowAny.mainIndexOffline);
        }
    }, [systemLoader]);

    if (systemLoader || config_loader) {
        return <LoaderFullScreen />;
    }

    return (
        <ThemeProvider key={appLanguage} theme={createMuiTheme(systemTheme, getLanguageDirection(language))}>
            <MuiPickersUtilsProvider utils={MomentUtils} locale={language}>
                {splashScreenOn && <SplashLoaderFullScreen withoutLoader />}
                <>
                    <CssBaseline />
                    <div className={classes.app_container}>
                        {loggedIn && userVerified && !hideLayoutLayout && (
                            <div className={classes.side_menu}>
                                <SideMenu onReferAndEarnClick={handleReferAndEarnClick} />
                            </div>
                        )}
                        <div className={classes.body} ref={scrollToTopElement}>
                            {(isPspIframeOpen || !hideLayoutLayout) && <Header disabled={true} />}

                            <main ref={myRef} className={classes.main}>
                                {isKeeperBannerShouldOpen && isOpenKeeperBanner && currentBannerType && (
                                    <div className={classes.keeper_container}>
                                        <KeeperAlertContent
                                            handleCloseAction={() => handleCloseKeeperBannerAction(currentBannerType)}
                                            styleOptions={StyleOption.KEEP_CHALLENGE_BANNER}
                                            keeperType={currentBannerType}
                                        />
                                    </div>
                                )}
                                <RefContext.Provider value={myRef}>
                                    <MainRouter />
                                </RefContext.Provider>
                            </main>
                            {loggedIn && (isPspIframeOpen || !hideLayoutLayout) && !useDisableBottomNav && (
                                <Hidden smUp>
                                    <div className={classes.bottomNavigationWrapper}>
                                        <MobileBottomNavigation />
                                    </div>
                                </Hidden>
                            )}
                            {!loggedIn && config.featuresFlags['disclaimer'] && <Disclaimer />}
                            {!loggedIn &&
                                !config.featuresFlags['disclaimer'] &&
                                config.featuresFlags['disclaimer-eu'] && <DisclaimerEu />}
                        </div>
                    </div>
                    <VersionPopup />
                    {loggedIn && userVerified && !isTablet() && <MsgPopup imageOnly />}
                    <DynamicScripts features={features} />
                    <WhatsAppButton />
                    <SnackbarWrapper />
                    <TradersEducationDialog onClose={system_toggleEducationModal} isOpen={educationModalState} />
                    {loggedIn && <ReferAndEarnPopup open={referAndEarnPopupOpen} onClose={closeReferAndEarnPopup} />}
                    <FundedInvestingManualKycDialogWithStoreConnection />
                    <ChallengeRetryDialog key={`ChallengeRetryDialog_${selectedChallenge?.tpName}`} />
                    <ChallengeRetryDisabledDialog key={`ChallengeRetryDisabledDialog_${selectedChallenge?.tpName}`} />
                    {loggedIn && currentType && !disableKeeperAlert && (
                        <KeeperAlertModal
                            key={`KeepChallengeModal_${currentType}_${selectedChallenge?.tpName}`}
                            keeperType={currentType}
                            selectedChallenge={selectedChallenge}
                            onExited={showNextModal}
                        />
                    )}
                </>
                {!!config['intercomAppId'] && !!config.featuresFlags['intercom'] && loggedIn && <IntercomChat />}
            </MuiPickersUtilsProvider>
            {loggedIn && !!config['reactAppChatBaseKey'] && <ChatDrawer />}
        </ThemeProvider>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(React.memo(App));
